import Drawer from 'components/Drawer'
import ArticleIcon from 'components/icons/ArticleIcon'
import BlueArrowIcon from 'components/icons/BlueArrowIcon'
import CalenderAddIcon from 'components/icons/CalenderAddIcon'
import ReleaseOffer from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ReleaseOfferDrawer/index'
import ScheduleInterview from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/index'
import {
  ContentDiv,
  MainFlex,
  TiltleDiv,
  TitleFlex,
} from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/Style/style'
import React, { useState } from 'react'
import CreateSlots from './CreateSlotDrawer'
import RequestDocumentdrawer from './ReqestDocument'

const BulkActionDrawer = ({
  bulkAction,
  setBulkAction,
  setScheduleDrawer,
  scheduleDrawer,
  releaseOffer,
  setReleaseOffer,
  selectedCandidateId,
  createSlotDrawer,
  setCreateSlotDrawer,
  selectedCandidate,
  rolesMetrics,
  getInterViewLocation,
  interViewData,
  createInterview,
  driveId,
  roleId,
  driveInterViewerList,
  getDriveInterviewerList,
  selectedRound,
  driveData,
  selectedRoundType,
  candidateDeatils,
  candidateInfoData,
  getCandidateList,
  getRoleMetrics,
  setSelectedCandidateId,
  setSelectedCandidate,
  getCities,
  cityList,
  releaseOfferAPI,
  stage,
  addCorporateBranch,
  getCorporateLocationsList,
  corporateLocationsList,
  deleteLocationAPI,
  getLocationDetails,
  singleRoleData,
  requestDocumentList,
  getRequestDocument,
  requestCandidateDocuments,
  singleLocationData,
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  listOfCountries,
  listOfStates,
  listOfCities,
  candidateIds,
  setCandidateIds,
  tabNames,
}) => {
  const isSingleOrBulk = selectedCandidate?.length > 1
  const [isConfirm, setIsConfirm] = useState(false)
  const [reqestDocumentDrawer, setReqestDocumentDrawer] = useState(false)

  const handleBulkActionChange = action => {
    if (action == 'slots') {
      setCreateSlotDrawer(true)
      setBulkAction(false)
    }
    if (action == 'schedule') {
      setScheduleDrawer(true)
      setBulkAction(false)
    }
    if (action == 'requestDocuments') {
      setBulkAction(false)
      setReqestDocumentDrawer(true)
    }
    if (action == 'relese') {
      setBulkAction(false)
      setReleaseOffer(true)
    }
  }

  const bulkOptions = [
    selectedRoundType?.type !== 'ASSESMENT' &&
    selectedRoundType?.type !== 'EXTERNAL_ASSESMENT'
      ? {
          key: 'slots',
          title: 'Create Slots',
          titleInfo: '',
          icon: <CalenderAddIcon />,
        }
      : null,
    {
      key: 'schedule',
      title: 'Schedule Interview',
      titleInfo: '',
      icon: <CalenderAddIcon />,
    },
    selectedRoundType?.type !== 'EXTERNAL_ASSESMENT'
      ? {
          key: 'requestDocuments',
          title: 'Request Document',
          titleInfo: '',

          icon: <CalenderAddIcon />,
        }
      : null,
    selectedRoundType?.type !== 'EXTERNAL_ASSESMENT'
      ? {
          key: 'relese',
          title: 'Release Intent to Offer',
          titleInfo: '',
          icon: <ArticleIcon />,
        }
      : null,
  ]

  const content = () => {
    return (
      <>
        {bulkOptions?.map((item, index) => (
          <>
            {item != null && (
              <MainFlex
                key={index + 'bulkUpload'}
                spaceBetween
                centerVertically
                row
                center
                onClick={() => handleBulkActionChange(item?.key)}
                disable={
                  item?.key === 'relese'
                    ? stage !== 'offer'
                    : stage === 'offer' && item?.key !== 'requestDocuments'
                }
              >
                <TitleFlex column>
                  <TitleFlex centerVertically>
                    {item?.icon}
                    <TiltleDiv>{item?.title}</TiltleDiv>
                  </TitleFlex>
                  <ContentDiv>{item?.titleInfo}</ContentDiv>
                </TitleFlex>
                <BlueArrowIcon />
              </MainFlex>
            )}
          </>
        ))}
      </>
    )
  }

  return (
    <>
      <Drawer
        width="40%"
        title={'Bulk Action'}
        placement="right"
        visible={bulkAction}
        content={content()}
        onClose={() => {
          setBulkAction(false)
        }}
        closable
      />
      <RequestDocumentdrawer
        selectedCandidateId={selectedCandidateId}
        selectedCandidate={selectedCandidate}
        setSelectedCandidateId={setSelectedCandidateId}
        setSelectedCandidate={setSelectedCandidate}
        rolesMetrics={rolesMetrics}
        getRoleMetrics={getRoleMetrics}
        setReqestDocumentDrawer={setReqestDocumentDrawer}
        reqestDocumentDrawer={reqestDocumentDrawer}
        getRequestDocument={getRequestDocument}
        requestDocumentList={requestDocumentList}
        requestCandidateDocuments={requestCandidateDocuments}
        setCandidateIds={setCandidateIds}
        candidateIds={candidateIds}
        driveId={driveId}
        roleId={roleId}
        isSingleOrBulk={isSingleOrBulk}
      />
      {scheduleDrawer && (
        <ScheduleInterview
          setScheduleDrawer={setScheduleDrawer}
          scheduleDrawer={scheduleDrawer}
          selectedCandidateId={selectedCandidateId}
          selectedCandidate={selectedCandidate}
          rolesMetrics={rolesMetrics}
          createInterview={createInterview}
          driveId={driveId}
          roleId={roleId}
          driveInterViewerList={driveInterViewerList}
          getDriveInterviewerList={getDriveInterviewerList}
          selectedRound={selectedRound}
          driveData={driveData}
          selectedRoundType={selectedRoundType}
          candidateDeatils={candidateDeatils}
          candidateInfoData={candidateInfoData}
          getCandidateList={getCandidateList}
          getRoleMetrics={getRoleMetrics}
          setSelectedCandidateId={setSelectedCandidateId}
          setSelectedCandidate={setSelectedCandidate}
          isSingleOrBulk={isSingleOrBulk}
        />
      )}
      {createSlotDrawer && (
        <CreateSlots
          selectedCandidateId={selectedCandidateId}
          selectedCandidate={selectedCandidate}
          rolesMetrics={rolesMetrics}
          createInterview={createInterview}
          createSlotDrawer={createSlotDrawer}
          setCreateSlotDrawer={setCreateSlotDrawer}
          driveId={driveId}
          roleId={roleId}
          driveInterViewerList={driveInterViewerList}
          getDriveInterviewerList={getDriveInterviewerList}
          selectedRound={selectedRound}
          driveData={driveData}
          selectedRoundType={selectedRoundType}
          candidateDeatils={candidateDeatils}
          candidateInfoData={candidateInfoData}
          getCandidateList={getCandidateList}
          getRoleMetrics={getRoleMetrics}
          setSelectedCandidateId={setSelectedCandidateId}
          setSelectedCandidate={setSelectedCandidate}
          isSingleOrBulk={isSingleOrBulk}
          getInterViewLocation={getInterViewLocation}
          interViewData={interViewData}
          singleLocationData={singleLocationData}
          getListOfCountries={getListOfCountries}
          getListOfStates={getListOfStates}
          getListOfCities={getListOfCities}
          listOfCountries={listOfCountries}
          listOfStates={listOfStates}
          listOfCities={listOfCities}
          getCorporateLocationsList={getCorporateLocationsList}
          corporateLocationsList={corporateLocationsList}
          deleteLocationAPI={deleteLocationAPI}
          getLocationDetails={getLocationDetails}
          addCorporateBranch={addCorporateBranch}
        />
      )}
      {(releaseOffer || isConfirm) && (
        <ReleaseOffer
          releaseOffer={releaseOffer}
          setReleaseOffer={setReleaseOffer}
          selectedCandidate={selectedCandidate}
          candidateDeatils={candidateDeatils}
          isSingleOrBulk={isSingleOrBulk}
          getCities={getCities}
          cityList={cityList}
          releaseOfferAPI={releaseOfferAPI}
          driveId={driveId}
          roleId={roleId}
          selectedCandidateId={selectedCandidateId}
          setSelectedCandidate={setSelectedCandidate}
          setSelectedCandidateId={setSelectedCandidateId}
          rolesMetrics={rolesMetrics}
          singleRoleData={singleRoleData}
          getCandidateList={getCandidateList}
          isConfirm={isConfirm}
          setIsConfirm={setIsConfirm}
          driveData={driveData}
          tabNames={tabNames}
        />
      )}
    </>
  )
}

export default BulkActionDrawer
